import { createContext, useContext } from "react";

export const CanvasBindingsContext: React.Context<Record<string, any>> = createContext(null);
export const useCanvasBindings: () => Record<string, any> = () => useContext(CanvasBindingsContext);